import styled from 'styled-components';
import Box from '../../_shared/components/Box';
import CopyToClipboard from '../../_shared/components/CopyToClipboard';
import isOmpPlatform from '../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const Wrapper = styled.div`
  max-width: 1146px;
  margin: 0 auto;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    max-width: 100%;
  }
`;

export const RetailVdpContainer = styled.div`
  display: grid;
  grid-column-gap: 12px;
  grid-template-columns: auto auto;
  grid-template-rows: 722px auto;
  grid-template-areas:
    'carousel siderail'
    'header siderail'
    'details siderail'
    'footer footer';

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'carousel' 'header' 'siderail' 'details' 'footer';
  }
`;

export const CopyUrlButton = styled.span`
  text-decoration: ${isOmp ? 'none' : 'underline'};
  margin-right: 12px;
  padding-left: 4px;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
`;

export const DetailsSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  max-width: max-content;
  grid-area: details;
  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    margin: 0 auto;
  }
`;

export const Footer = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  margin-top: 60px;
  padding: 24px 0 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 60px auto 0;
  grid-area: footer;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    margin: 0 20px;
    max-width: fit-content;
  }
`;

export const FooterText = styled.p`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-top: 32px;
`;

export const StyledRetailVdpErrorContainer = styled(Box.Column)`
  align-items: center;
  vertical-align: middle;
  margin: 0;
  position: relative;
  top: 50vh;
  svg {
    width: 36px;
    height: 36px;
    align: center;
    margin-bottom: 24px;
  }
`;

export const StyledCopyToClipboard = styled(CopyToClipboard)`
  padding: 10px 0 15px 0;
  justify-content: flex-end;
`;
